import React from "react";
import styled from "styled-components";

interface AdminLoginProps {
  email: string;
  password: string;
  error: string;
  message: string;
  isLoading: boolean;
  onEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPasswordChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
}

const AdminLogin: React.FC<AdminLoginProps> = ({
  email,
  password,
  error,
  message,
  isLoading,
  onEmailChange,
  onPasswordChange,
  onSubmit,
}) => {
  return (
    <ModalOverlay>
      <LoginBox>
        <Title>관리자 로그인</Title>
        {error && <ErrorMessage>{error}</ErrorMessage>}
        {message && <SuccessMessage>{message}</SuccessMessage>}
        <Form onSubmit={onSubmit}>
          <InputGroup>
            <Label>아이디 또는 이메일</Label>
            <Input
              type="text"
              value={email}
              onChange={onEmailChange}
              autoComplete="username"
              required
            />
          </InputGroup>
          <InputGroup>
            <Label>비밀번호</Label>
            <Input
              type="password"
              value={password}
              onChange={onPasswordChange}
              required
            />
          </InputGroup>
          <LoginButton type="submit" disabled={isLoading}>
            {isLoading ? "로그인 중..." : "로그인"}
          </LoginButton>
        </Form>
      </LoginBox>
    </ModalOverlay>
  );
};

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
`;

const LoginBox = styled.div`
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 450px;
  margin: 20px;
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: 30px;
  color: #2c3e50;
  font-size: 28px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const InputGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  font-size: 15px;
  color: #495057;
  font-weight: 600;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  font-size: 15px;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #27c360;
    box-shadow: 0 0 0 3px rgba(39, 195, 96, 0.1);
  }
`;

const LoginButton = styled.button`
  width: 100%;
  margin-top: 20px;
  height: 48px;
  background-color: #27c360;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.2s ease;

  &:hover {
    background-color: #229a4c;
    transform: translateY(-1px);
  }

  &:disabled {
    background-color: #adb5bd;
    cursor: not-allowed;
    transform: none;
  }
`;

const ErrorMessage = styled.div`
  color: #dc3545;
  text-align: center;
  margin-bottom: 20px;
  padding: 12px;
  background-color: #f8d7da;
  border-radius: 8px;
  font-weight: 500;
`;

const SuccessMessage = styled.div`
  color: #28a745;
  text-align: center;
  margin-bottom: 20px;
  padding: 12px;
  background-color: #d4edda;
  border-radius: 8px;
  font-weight: 500;
`;

export default AdminLogin;
